import { render, staticRenderFns } from "./RealNameReport.vue?vue&type=template&id=7c3652d6&scoped=true&"
import script from "./RealNameReport.vue?vue&type=script&lang=js&"
export * from "./RealNameReport.vue?vue&type=script&lang=js&"
import style0 from "./RealNameReport.vue?vue&type=style&index=0&id=7c3652d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3652d6",
  null
  
)

export default component.exports